import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../services/api";
import axiosPrivate from "../../services/axios/axiosPrivate";
import { toast } from "react-toastify";

export const updateEmployeeProfileDetails = createAsyncThunk('employeeProfile/updateEmployeeProfileDetails',
  async ({ employeeId, payload }, { rejectWithValue }) => {
    console.log('employeeId, payload',employeeId, payload)
    try {
      const response = await axiosPrivate.post(`${api.updateEmployeeDetails}${employeeId}`, payload);
      console.log('updateEmployeeProfileDetails response:', response.data);
      if (response.data.success === true) {
        toast.success(response.data.reason, {
          className: "toast-success-custom",
        });
      } else {
        toast.error(response.data.reason, {
          className: "toast-error-custom",
        });
      }
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || "Unable to connect to server");
    }
  })

const updateEmployeeProfileSlice = createSlice({
  name: 'employeeProfile',
  initialState: {
    employeeProfile: {},
    status: 'idle',
    loading: false,
    error: null
  },
  reducers: {},
  extraReducers: (builders) => {
    builders
      .addCase(updateEmployeeProfileDetails.pending,
        (state) => {
          state.status = 'loading';
          state.loading = true;
          state.error = null;
        })
      .addCase(updateEmployeeProfileDetails.fulfilled,
        (state, action) => {
          state.status = 'succeeded';
          state.loading = false;
          state.employeeProfile = action.payload;
        })
      .addCase(updateEmployeeProfileDetails.rejected,
        (state, action) => {
          state.status = 'failed';
          state.loading = false;
          state.error = action.payload;
        }
      )
  }
})

export default updateEmployeeProfileSlice.reducer;